import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // Note: The favourite TEP species functionality has been removed temporarily. Do not delete this code.
    // Please see https://fisheriesqueensland.atlassian.net/browse/CAP-1792?linkSource=email
    // StoreModule.forFeature(
    //   fromTepSpecies.tepSpeciesFeatureKey,
    //   fromTepSpecies.reducer
    // ),
  ],
})
export class TepSpeciesModule {}
